/** Textes « decalageEncaissement » — le français fait foi. */

/** « d'octobre », « d'août », « de septembre ». */
const de = (nom: string) => (/^[aeiouéèh]/i.test(nom) ? `d'${nom}` : `de ${nom}`);
/** « une location », « 3 locations ». */
const locations = (n: number) => (n > 1 ? `${n} locations` : 'une location');

export const decalageEncaissement = {
  /** Langue des noms de mois (« octobre »). */
  localeMois: 'fr-FR',
  /** « une location d'octobre », « 3 locations de septembre ». */
  locationsDuMois: (n: number, nom: string) => `${locations(n)} ${de(nom)}`,
  /** Où se trouve l'argent reçu tel mois. */
  ou: {
    caisse: (nom: string) => `dans la caisse ${de(nom)}`,
    banque: (nom: string) => `à la banque (reçus en ${nom})`,
    mixte: (nom: string, m: string) => `dans la caisse ${de(nom)}, dont ${m} à la banque`,
  },
  notes: {
    dont: 'Dont ',
    avance: (pour: string) => ` encaissés d'avance pour ${pour}.`,
    retard: (pour: string) => ` reçus ce mois-ci pour ${pour}.`,
    annulee: ' sur une location annulée depuis.',
    banque: ' à la banque (chèque, virement), pas dans la caisse.',
    dejaAvant: (mois: string, n: number) => `Déjà encaissés en ${mois} pour ${locations(n)} de ce mois : `,
    dejaApres: (ou: string) => ` — ${ou}, pas dans celle-ci.`,
    plusTardAvant: (mois: string, n: number) => `Encaissés plus tard, en ${mois}, pour ${locations(n)} de ce mois : `,
    plusTardApres: (ou: string) => ` — ${ou}.`,
  },
  dontBanque: (m: string) => ` (dont ${m} à la banque)`,
  voirVoitureEn: (mois: string) => `Voir cette voiture en ${mois}`,
  ouvrirCaisseDe: (nom: string) => `Ouvrir la caisse ${de(nom)}`,
  pour: (pour: string) => `Pour ${pour} : `,
  encaissesEn: (mois: string) => `Encaissés en ${mois} : `,
  virguleOu: (ou: string) => `, ${ou}.`,
  avance: {
    titre: (m: string) => `${m} encaissés ce mois-ci d'avance`,
    texte: (plusieurs: boolean) => `Cet argent est entré ce mois-ci, mais il paie ${plusieurs
      ? 'des locations qui auront lieu plus tard'
      : 'une location qui aura lieu plus tard'}.`,
  },
  deja: {
    titre: (m: string) => `${m} de ce mois ont été encaissés un mois précédent`,
    texte: (plusieurs: boolean) => `${plusieurs
      ? 'Des locations de ce mois ont été payées d\'avance.'
      : 'Une location de ce mois a été payée d\'avance.'} Cet argent n'est pas compté ici : il est dans le mois où il a été reçu.`,
  },
  retard: { titre: (m: string) => `${m} reçus ce mois-ci pour des locations des mois précédents` },
  plusTard: { titre: (m: string) => `${m} de ce mois ont été encaissés plus tard` },
  annulee: {
    titre: (m: string) => `${m} encaissés sur une location annulée depuis`,
    texte: 'La location a été annulée, mais l\'argent reçu est resté dans le mois qui l\'a reçu.',
  },
};
